import alt from '../alt';

/**
 * Define the actions we can call from the view.
 * If the action only processes data, then dispatch to store by returning the data. ie:
 *  ```
 *  test() { return []; }
 *  ```
 *
 * If the action has to dispatch after Promise resolves, return a function that accepts `dispatch` as param
 * and then call `dispatch(data)` when the promise resolves. ie:
 * ```
 * test() {
 *    return (dispatch) => {
 *      asyncMethod()
 *        .then((data) => {
 *          dispatch(data);
 *        })
 *    }
 *  }
 * ```
 */
class RegistrationActionsClass {
  /**
   * If the
   * @param data
   * @returns {function(*)}
   */
  signup(data) {
    return (dispatch) => {
      new Promise((resolve, reject) => {
        dispatch(data);
      });
    };
  }

  goToStep(stepNumber) {
    return { stepNumber };
  }

  formFieldChange(data) {
    return data;
  }

  setLoading(isLoading) {
      return { isLoading};
  }

  changeModalFromUrlStatus(isModalWithUrlMessageOpen){
    return { isModalWithUrlMessageOpen }
  }
}

export let RegistrationActions = alt.createActions(RegistrationActionsClass);


// WEBPACK FOOTER //
// ./registration-react/registration.actions.js